import * as React from "react";
import styles from "./Summary.module.scss";
import {Trans, useTranslation} from "react-i18next";

const SummaryDisclaimer: React.FC = () => {
  const {t} = useTranslation(["errorcodes", "translations"]);

  return (
    <p className={styles.disclaimer}>
      <Trans
        i18nKey="general.disclaimer"
        ns="translations"
        components={{
          a: <a href={t("url.termsAndConditionsLink")} target="_blank" rel="noreferrer" />,
          b: <a href={t("url.privacyLink")} target="_blank" rel="noreferrer" />,
          c: <a href={t("url.withdrawalLink")} target="_blank" rel="noreferrer" />,
        }}
      />
    </p>
  );
};

export default SummaryDisclaimer;
